import React, { useCallback, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { TextField } from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import { BackgroundIcon } from '@nile/components';
import { SecuredFieldContainer } from './styles';
import { SVGIcon } from '@superops/super-icons';
/**
 *
 * @param {object} props
 * Secured field component takes value as props
 * Toggles to display password or masked value
 * @returns
 */

function SecuredField(props) {
  const { fieldType, label, placeholder } = props;
  const [type, setType] = useState('password');
  const [value, setValue] = useState(props.value || '');

  function toggleType() {
    type === 'password' ? setType('text') : setType('password');
  }

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleChange = useCallback((newValue) => {
    setValue(newValue);
    props.handleChange(newValue);
  }, []);

  return (
    <SecuredFieldContainer>
      <div className="input-field-container">
        <TextField
          label={label}
          type={type || fieldType}
          onChange={handleChange}
          value={value}
          placeholder={placeholder || ''}
        />
      </div>
      <div onClick={toggleType} className="eye-icon">
        <SVGIcon name={type === 'password' ? 'EyeHidden' : 'EyeVisible'} />
      </div>
    </SecuredFieldContainer>
  );
}

export default injectIntl(SecuredField);
